import { useState, useEffect } from 'react'
import PubSub from 'pubsub-js'
import { gql } from '@apollo/client'
import { Alert, Table } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { GET_PACKAGE_SOURCE_QUERY } from '../../../graphql.js'
import { handleGraphQLErrors } from '../../../utils.js'

export const GET_PACKAGE_SOURCE = gql(GET_PACKAGE_SOURCE_QUERY)

export default function PackageSource() {
  console.log('PackageSource rendered')

  const [packageInfo, setPackageInfo] = useState()
  const [spinner, setSpinner] = useState(false)
  const [items, setItems] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    function handlePackageSelected(msg, data) {
      console.log(`EVENT RECEIVED (PackageSource): ${msg}`, data)
      setPackageInfo(data)
      fetchPackageSource(data)
    }
    const eventToken = PubSub.subscribe('PACKAGE SELECTED', handlePackageSelected)
    return function cleanup() {
      PubSub.unsubscribe(eventToken)
    }
  })

  async function fetchPackageSource(packageInfo) {
    try {
      setSpinner(true)
      const { data, errors } = await window.apolloClient.query({ query: GET_PACKAGE_SOURCE, variables: { owner: packageInfo.owner, name: packageInfo.name } })
      console.log('GET_PACKAGE_SOURCE data: ', { data })
      if (data.getPackageSource) {
        const lines = []
        for (let line of data.getPackageSource) {
          lines.push(
            <tr key={`${line.line}`}>
              <td style={{ textAlign: 'right' }}><code>{line.line}</code></td>
              <td style={{ textAlign: 'left', whiteSpace:'pre' }}><code>{line.text}</code></td>
            </tr>)
        }
        setItems(lines)
      }
      if (errors) {
        setGraphQLErrors(errors)
      }
    } catch (err) {
      handleGraphQLErrors(err, setGraphQLErrors)
    } finally {
      setSpinner(false)
    }
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  if (spinner) {
    return <Spinner />
  }

  if (items && items.length > 0) {
    return (
      <div style={{ marginTop: '20px', marginBottom: '40px' }}>
        <Table bordered style={{ padding: '.25rem', width: 'auto', margin: 'auto' }}>
          <thead>
            <tr>
              <th colSpan={4}>{packageInfo.name}</th>
            </tr>
          </thead>
          <tbody>
            {items}
          </tbody>
        </Table>
      </div>
    )
  } else {
    return ''
  }
}
